import {ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme} from "@mui/material"

declare module "@mui/material/Button" {
    export interface ButtonPropsVariantOverrides {
        customVariant: true
    }
}

type muiButtonBase = {
    defaultProps?: ComponentsProps["MuiButtonBase"]
    styleOverrides?: ComponentsOverrides<Theme>["MuiButtonBase"]
    variants?: ComponentsVariants["MuiButtonBase"]
}

type muiButton = {
    defaultProps?: ComponentsProps["MuiButton"]
    styleOverrides?: ComponentsOverrides<Theme>["MuiButton"]
    variants?: ComponentsVariants["MuiButton"]
}

type muiIconButton = {
    defaultProps?: ComponentsProps["MuiIconButton"]
    styleOverrides?: ComponentsOverrides<Theme>["MuiIconButton"]
    variants?: ComponentsVariants["MuiIconButton"]
}

type muiListItemButton = {
    defaultProps?: ComponentsProps["MuiListItemButton"]
    styleOverrides?: ComponentsOverrides<Theme>["MuiListItemButton"]
    variants?: ComponentsVariants["MuiListItemButton"]
}

export const MuiButtonBase: muiButtonBase = {
    defaultProps: {
        color: "#fff",
        disableRipple: true,
    },
    styleOverrides: {
        root: {
            // width: "100%",
            textTransform: "none",
            borderRadius: "4px",
            fontWeight: 500,
            fontSize: "15px",
            transition: "none",
        },
    },
}

export const MuiListItemButton: muiListItemButton = {
    styleOverrides: {
        root: {
            "&:hover": {
                backgroundColor: "#EBEEFD !important",
                fontWeight: 500,
            },
            marginLeft: "6px",
            marginRight: "6px",
            padding: "0 !important",
            paddingLeft: "5px !important",
            borderRadius: "4px !important",
            "&.Mui-selected": {
                backgroundColor: "transparent",
                fontWeight: 500,
            },
        },
    },
}

export const MuiIconButton: muiIconButton = {
    styleOverrides: {
        root: {
            // width: "100%",
            "&:hover": {
                backgroundColor: "none",
            },
        },
    },
}

export const MuiButton: muiButton = {
    styleOverrides: {
        root: {
            fontFamily: "'Roboto'",
            textTransform: "none",
            width: "fit-content",
            alignItems: "center",
        },
    },
    variants: [
        {
            props: {variant: "contained", size: "medium"},
            style: () => {
                return {
                    textTransform: "none",
                    borderRadius: "4px",
                    background: "#101941",
                    fontWeight: 500,
                    fontSize: "15px",
                    transition: "none",
                    boxShadow: "none",
                    padding: "0 !important",
                    "&:hover": {
                        boxShadow: "none",
                        // background: "transparent",
                    },
                    "&:disabled": {
                        background: "#3c42577a",
                        color: "#fff",
                    },
                }
            },
        },
        {
            props: {size: "medium"},
            style: () => {
                return {
                    minWidth: "160px",
                    height: "30px",
                }
            },
        },
        {
            props: {size: "small"},
            style: () => {
                return {
                    minWidth: "68px",
                    height: "30px",
                    borderRadius: "5px",
                    fontSize: 12,
                    textTransform: "none",
                    // "&:hover": {
                    //     background: "transparent",
                    // },
                    "&:disabled": {
                        background: "#3c42573b",
                        color: "#fff",
                    },
                }
            },
        },
    ],
}
